import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { useUtils as useI18nUtils } from '@core/libs/i18n'

export default function useAmenityList() {
    const { t } = useI18nUtils()
    const tableColumns = [
        { key: 'icon', label: 'Icon', sortable: false },
        { key: 'title', label: 'Title', sortable: false },
        { key: 'slug', label: 'Slug', sortable: false },
        { key: 'is_active', label: 'Status', sortable: false },
        { key: 'action', label: '#', sortable: false }
    ];
    const isAmenityFormSidebarActive = ref(false)
    const amenityData = ref(null)
    const amenities = ref([])
    const currentPage = ref(1)
    const perPage = ref(10)
    const searchQuery = ref('')
    const statusFilter = ref(null)
    const totalAmenities = ref(0)
    const refAmenityListTable = ref(null)
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const toast = useToast()
    const dataMeta = computed(() => {
        const from = Math.max(1, perPage.value * (currentPage.value - 1) + 1);
        const to = Math.min(
            totalAmenities.value,
            perPage.value * currentPage.value
        );
        return {
            from,
            to,
            of: totalAmenities.value,
        }
    })

    const refetchAmenityData = () => {
        fetchAmenityData();
    }

    watch([currentPage, perPage, searchQuery, statusFilter], () => {
        refetchAmenityData()
    })

    const fetchAmenityData = (ctx, callback) => {
        const offset = perPage.value*(currentPage.value-1);
        const getLocalSite = JSON.parse(localStorage.getItem('site'))

        store
            .dispatch('app-room/getAmenities', {
                limit: perPage.value,
                offset:offset,
                keywords: searchQuery.value,
                sites_id: getLocalSite.id
            })
            .then(response => {
                amenities.value = response.data.data
                totalAmenities.value = response.data.total
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: "Error fetching Category' list",
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            })
    }

    const resolveAmenityStatusVariant = status => {
        if (status ) return 'success'
        if (!status ) return 'secondary'
        return 'primary'
    }

    const resolveAmenityStatusnameVariant = status => {
        if (status) return 'Active'
        if (!status) return 'Inactive'
        return 'primary'
    }

    const updateAmenity = (data) => {
        if(typeof(data) === 'object' && data !== null){
            amenityData.value = JSON.parse(JSON.stringify(data))
        } else {
            amenityData.value = data
        }
        
        isAmenityFormSidebarActive.value = true
    }

    const deleteData = (id) => {
        store.dispatch('app-room/deleteAmenity',id).then(response=>{
            toast({
                component: ToastificationContent,
                props: {
                title: "Delete Success",
                icon: 'AlertTriangleIcon',
                variant: 'success',
                },
            })
            fetchAmenityData();
        }).catch((error)=>{
            toast({
                component: ToastificationContent,
                props: {
                    title: "Error Delete Food Category",
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    return {
        dataMeta,
        tableColumns,
        isAmenityFormSidebarActive,
        refetchAmenityData,
        fetchAmenityData,
        updateAmenity,
        resolveAmenityStatusVariant,
        resolveAmenityStatusnameVariant,
        refAmenityListTable,
        amenities,
        sortBy,
        isSortDirDesc,
        totalAmenities,
        amenityData,
        deleteData,
        t,
        perPage,
        currentPage,
        searchQuery,
    }
}